module.exports = __webpack_public_path__ + "static/media/bnb-logo.7ae10f58.png";